module.exports = __webpack_public_path__ + "static/android-icon-192x192-b45251119b4e54c1645212e637b625ea.png";